import Vue from 'vue'
import Router from 'vue-router'
import BottomNavVue from "../components/BottomNavVue";
import BookCityVue from "../components/BookCityVue";
import BookShelfVue from "../components/BookShelfVue";
import MineVue from "../components/MineVue";
import LoginVue from "../components/LoginVue";
import SelectedVue from "../components/SelectedVue";
import RankingVue from "../components/RankingVue";
import BookRoomVue from "../components/BookRoomVue";
import BookDetailVue from "../components/BookDetailVue";
import LookHistoryVue from "../components/LookHistoryVue";
import ChapterDetailVue from "../components/ChapterDetailVue";
import CardPayVue from "../components/CardPayVue";
import SearchVue from "../components/SearchVue";
import SingleDiscountVue from "../components/SingleDiscountVue";
import PackageDiscountVue from "../components/PackageDiscountVue";
import RechargeHistoryVue from "../components/RechargeHistoryVue";
import FeedbackVue from "../components/FeedbackVue";
import RegisterVue from "../components/RegisterVue";
import BuyHistory from "../components/BuyHistory";
import CatalogVue from "../components/CatalogVue";
import StartRechargeVue from "../components/StartRechargeVue";
import DownloadVue from "../components/DownloadVue";
import BlankVue from "../components/BlankVue";
import PrivacyPolicyVue from "../components/PrivacyPolicyVue";
import DataDeletionVue from "../components/DataDeletionVue";

Vue.use(Router)
const VueRouterPush = Router.prototype.push
Router.prototype.push = function push(to) {
        return VueRouterPush.call(this, to).catch(err => err)
}

export default new Router({
        routes: [
                {
                        path: '/', redirect: '/BottomNavVue'
                },
                {
                        path: '/BottomNavVue',
                        name: 'BottomNavVue',
                        component: BottomNavVue,
                        children: [
                                {
                                        path: '/', redirect: '/BookCityVue'
                                },
                                {
                                        path: '/BookCityVue',
                                        name: "BookCityVue",
                                        component: BookCityVue,
                                        children: [
                                                {
                                                        path: '/', redirect: '/SelectedVue'
                                                },
                                                {
                                                        path: '/SelectedVue',
                                                        name: "SelectedVue",
                                                        component: SelectedVue,
                                                        title: "mysread",
                                                        meta: {
                                                                keepAlive: true, //此組件需要被緩存
                                                                isBack: false, //用於判斷上壹個頁面是哪個
                                                        }
                                                },
                                                {
                                                        path: '/RankingVue',
                                                        name: "RankingVue",
                                                        component: RankingVue,
                                                        title: "mysread",
                                                        meta: {
                                                                keepAlive: true, //此組件需要被緩存
                                                                isBack: false, //用於判斷上壹個頁面是哪個
                                                        }
                                                },
                                                {
                                                        path: '/BookRoomVue',
                                                        name: "BookRoomVue",
                                                        component: BookRoomVue,
                                                        title: "mysread",
                                                        meta: {
                                                                keepAlive: true, //此組件需要被緩存
                                                                isBack: false, //用於判斷上壹個頁面是哪個
                                                        }
                                                }
                                        ]
                                },
                                {
                                        path: '/BookShelfVue',
                                        name: "BookShelfVue",
                                        component: BookShelfVue,
                                        title: "mysread",
                                        meta: {
                                                keepAlive: false, //此組件需要被緩存
                                                isBack: false, //用於判斷上壹個頁面是哪個
                                        }
                                },
                                {
                                        path: '/MineVue',
                                        name: "MineVue",
                                        component: MineVue,
                                        title: "mysread",
                                        meta: {
                                                keepAlive: true, //此組件需要被緩存
                                                isBack: false, //用於判斷上壹個頁面是哪個
                                        }
                                },
                        ]
                },
                {
                        path: '/LoginVue',
                        name: 'LoginVue',
                        component: LoginVue,
                        title: "mysread",
                        meta: {
                                keepAlive: false, //此組件不需要被緩存
                                isBack: false, //用於判斷上壹個頁面是哪個
                        }
                },
                {
                        path: '/BookDetailVue',
                        name: 'BookDetailVue',
                        component: BookDetailVue,
                        title: "mysread",
                        meta: {
                                keepAlive: false, //此組件需要被緩存
                                isBack: false, //用於判斷上壹個頁面是哪個
                        }
                },
                {
                        path: '/LookHistoryVue',
                        name: 'LookHistoryVue',
                        component: LookHistoryVue,
                        title: "mysread",
                        meta: {
                                keepAlive: true, //此組件需要被緩存
                                isBack: false, //用於判斷上壹個頁面是哪個
                        }
                },
                {
                        path: '/ChapterDetailVue',
                        name: 'ChapterDetailVue',
                        component: ChapterDetailVue,
                        title: "mysread",
                        meta: {
                                keepAlive: false, //此組件不需要被緩存
                                isBack: false, //用於判斷上壹個頁面是哪個
                        }
                },
                {
                        path: '/CardPayVue',
                        name: 'CardPayVue',
                        component: CardPayVue,
                        title: "mysread",
                        meta: {
                                keepAlive: false, //此組件不需要被緩存
                                isBack: false, //用於判斷上壹個頁面是哪個
                        }
                },
                {
                        path: '/SearchVue',
                        name: 'SearchVue',
                        component: SearchVue,
                        title: "mysread",
                        meta: {
                                keepAlive: true, //此組件需要被緩存
                                isBack: false, //用於判斷上壹個頁面是哪個
                        }
                },
                {
                        path: '/SingleDiscountVue',
                        name: 'SingleDiscountVue',
                        component: SingleDiscountVue,
                        title: "mysread",
                        meta: {
                                keepAlive: false, //此組件不需要被緩存
                                isBack: false, //用於判斷上壹個頁面是哪個
                        }
                },
                {
                        path: '/PackageDiscountVue',
                        name: 'PackageDiscountVue',
                        component: PackageDiscountVue,
                        title: "mysread",
                        meta: {
                                keepAlive: false, //此組件不需要被緩存
                                isBack: false, //用於判斷上壹個頁面是哪個
                        }
                },
                {
                        path: '/RechargeHistoryVue',
                        name: 'RechargeHistoryVue',
                        component: RechargeHistoryVue,
                        title: "mysread",
                        meta: {
                                keepAlive: false, //此組件不需要被緩存
                                isBack: false, //用於判斷上壹個頁面是哪個
                        }
                },
                {
                        path: '/FeedbackVue',
                        name: 'FeedbackVue',
                        component: FeedbackVue,
                        title: "mysread",
                        meta: {
                                keepAlive: false, //此組件不需要被緩存
                                isBack: false, //用於判斷上壹個頁面是哪個
                        }
                },
                {
                        path: '/RegisterVue',
                        name: 'RegisterVue',
                        component: RegisterVue,
                        title: "mysread",
                        meta: {
                                keepAlive: false, //此組件不需要被緩存
                                isBack: false, //用於判斷上壹個頁面是哪個
                        }
                },
                {
                        path: '/BuyHistory',
                        name: 'BuyHistory',
                        component: BuyHistory,
                        title: "mysread",
                        meta: {
                                keepAlive: false, //此組件不需要被緩存
                                isBack: false, //用於判斷上壹個頁面是哪個
                        }
                },
                {
                        path: '/PrivacyPolicyVue',
                        name: 'PrivacyPolicyVue',
                        component: PrivacyPolicyVue,
                        title: "mysread",
                        meta: {
                                keepAlive: false, //此組件不需要被緩存
                                isBack: false, //用於判斷上壹個頁面是哪個
                        }
                },
                {
                        path: '/DataDeletionVue',
                        name: 'DataDeletionVue',
                        component: DataDeletionVue,
                        title: "mysread",
                        meta: {
                                keepAlive: false, //此組件不需要被緩存
                                isBack: false, //用於判斷上壹個頁面是哪個
                        }
                },
                {
                        path: '/CatalogVue',
                        name: 'CatalogVue',
                        component: CatalogVue,
                        title: "mysread",
                        meta: {
                                keepAlive: false, //此組件不需要被緩存
                                isBack: false, //用於判斷上壹個頁面是哪個
                        }
                },
                {
                        path: '/StartRechargeVue',
                        name: 'StartRechargeVue',
                        component: StartRechargeVue,
                        title: "mysread",
                        meta: {
                                keepAlive: false, //此組件不需要被緩存
                                isBack: false, //用於判斷上壹個頁面是哪個
                        }
                },
                {
                        path: '/DownloadVue',
                        name: 'DownloadVue',
                        component: DownloadVue,
                        title: "mysread",
                        meta: {
                                keepAlive: false, //此組件不需要被緩存
                                isBack: false, //用於判斷上壹個頁面是哪個
                        }
                },
                {
                        path: '/BlankVue',
                        name: 'BlankVue',
                        component: BlankVue,
                        title: "mysread",
                        meta: {
                                keepAlive: false, //此組件不需要被緩存
                                isBack: false, //用於判斷上壹個頁面是哪個
                        }
                }
        ]
})



// WEBPACK FOOTER //
// ./src/router/index.js